import React from 'react';
import PropTypes from 'prop-types';
import useNudata from 'stash/hooks/nudata';

const NUDATA_PUBLIC_CLIENT_IDS = {
	__STASH_ENV__: 'w-844120',
	edge: 'w-844120',
	staging: 'w-969583',
	production: 'w-182165',
};

const NudataSDK = (props) => {
	const { nudataSession } = useNudata();
	const STASH_ENV = window && window.Stash.env;
	const nudataClientId = NUDATA_PUBLIC_CLIENT_IDS[STASH_ENV];

	const initNudataSdk = () => {
		const baseUrl =
			'https://nd.stash.com/2.2/w/' + nudataClientId + '/sync/js/';

		(function (w, d, s, u, q, js, fjs, nds) {
			nds = w.ndsapi || (w.ndsapi = {});
			nds.config = {
				q: [],
				ready: function (cb) {
					this.q.push(cb);
				},
			};
			js = d.createElement(s);
			fjs = d.getElementsByTagName(s)[0];
			js.src = u;
			fjs.parentNode.insertBefore(js, fjs);
			js.onload = function () {
				nds.load(u);
			};
		})(window, document, 'script', baseUrl);

		const nds = window.ndsapi;

		nds.config.ready(function () {
			nds.setSessionId(nudataSession.id);

			nds.setPlacement(props.placementName);
			nds.setPlacementPage(props.placementPage);

			nds.bindNewFields();
		});
	};

	return (
		<script type="text/javascript">
			{nudataSession?.id ? initNudataSdk() : null}
		</script>
	);
};

NudataSDK.propTypes = {
	placementName: PropTypes.string,
	placementPage: PropTypes.number,
};

export default NudataSDK;
